import classNames from 'classnames'
import React, { SFC } from 'react'

// @TODO: add styles for tight, centered etc...
// import './TableColumn.less'

type Props = {
  tight?: boolean
  centered?: boolean
  headerTitle?: string
  colSpan?: number
}

const TableColumn: SFC<Props> = ({ children, tight = false, centered = false, headerTitle, colSpan }) => {
  const className = classNames({
    'tight-table-column': tight,
    'text-center': centered,
  })

  return (
    <td className={className} data-header={headerTitle} colSpan={colSpan}>
      {children}
    </td>
  )
}

export { TableColumn }



// WEBPACK FOOTER //
// ./src/app/shared/smart-table/components/table-column.component.tsx